import styled from "@emotion/styled";
import { Button, BodyText, Heading3, SecondaryText } from "@silvertours/front-shared";
var PricePrefixTextWrapper = /*#__PURE__*/ styled(SecondaryText, {
    target: "eccbgjo0"
})("white-space:nowrap;padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";text-align:right;font-variant-numeric:tabular-nums;");
var SubtitleWrapper = /*#__PURE__*/ styled(Heading3, {
    target: "eccbgjo1"
})("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";}");
var Container = /*#__PURE__*/ styled("div", {
    target: "eccbgjo2"
})("height:100%;border:", function(param) {
    var theme = param.theme;
    return "".concat(theme.color.natural20, " 1px solid");
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";box-shadow:", function(param) {
    var theme = param.theme;
    return theme.boxShadow.md;
}, ";cursor:", function(param) {
    var hasAction = param.hasAction;
    return hasAction ? "pointer" : "initial";
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");
var ImageWrapper = /*#__PURE__*/ styled("div", {
    target: "eccbgjo3"
})("border-bottom:", function(param) {
    var theme = param.theme;
    return "".concat(theme.color.natural20, " 1px solid");
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";display:flex;position:relative;height:130px;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:150px;margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";}");
var ProviderOffersList = /*#__PURE__*/ styled("ul", {
    target: "eccbgjo4"
})("display:flex;width:100%;flex-direction:column;");
var ProviderOffer = /*#__PURE__*/ styled("li", {
    target: "eccbgjo5"
})("display:flex;justify-content:space-between;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";");
var ProviderName = /*#__PURE__*/ styled(BodyText, {
    target: "eccbgjo6"
})("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";");
var SearchButton = /*#__PURE__*/ styled(Button, {
    target: "eccbgjo7"
})("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");
export { Container, ImageWrapper, ProviderName, ProviderOffer, ProviderOffersList, PricePrefixTextWrapper, SearchButton, SubtitleWrapper };
